import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=92844294&scoped=true&"
import script from "./clean.vue?vue&type=script&lang=js&"
export * from "./clean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92844294",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookieConsentBanner: require('/builds/ibjjf/ibjjf-web-ui-new/components/global/CookieConsentBanner.vue').default})
